module.exports = __webpack_public_path__ + "fonts/Graphik-Semibold.b1c2c00.woff2";